import { useState, Dispatch, SetStateAction } from 'react';
import { Menu, MenuItem, Radio, Typography } from '@mui/material';
import {
  updateOperationIncident,
  OperationIncident
} from '@networkRequest/operationsService';
import { useUser } from '@hooks/useUser';
import IncidentDetailItem from './IncidentDetailItem';
import { OPERATION_INCIDENT_STATUSES } from '../../../../constants';

const IncidentStatus = ({
  loading = false,
  incident,
  setIncident,
  setError,
}: {
  loading?: boolean;
  incident: OperationIncident;
  setIncident: Dispatch<SetStateAction<OperationIncident | null>>;
  setError: Dispatch<SetStateAction<string | null>>;
}) => {
  const { user } = useUser();
  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);

  if (!incident || ! user?.accessToken) return null;

  const handleEdit = async (newValue: string) => {
    const { data, error } = await updateOperationIncident({ 
      accessToken: user?.accessToken,
      incidentId: incident.id,
      payload: {
        incident_status: newValue,
      },
    })
    if (data) {
      setIncident(data);
    } else {
      setError(error ?? 'Faild to update incident');
    }
    setMenuAnchor(null);
  };

  return (
    <>
      <IncidentDetailItem
        name='Status'
        onClick={(e: any) => {setMenuAnchor(e.currentTarget)}}
      >
        <Typography variant='body1'>
          {OPERATION_INCIDENT_STATUSES?.[incident?.incident_status] ?? '\u00A0'}
        </Typography>
      </IncidentDetailItem>
      <Menu
        anchorEl={menuAnchor}
        open={Boolean(menuAnchor)}
        onClose={() => setMenuAnchor(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <MenuItem onClick={() => handleEdit('ongoing')} disabled={loading}>
          <Radio checked={incident.incident_status === 'ongoing'} />
          Ongoing
        </MenuItem>
        <MenuItem onClick={() => handleEdit('closed')}  disabled={loading}>
          <Radio checked={incident.incident_status === 'closed'} />
          Closed
        </MenuItem>
      </Menu>
    </>
  );
};

export default IncidentStatus;